import styled from "styled-components/macro";

export const ModalCon = styled.div`
  position: absolute;
  top: -10%;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const ModalWrapper = styled.div`
  background-color: white;
  border-radius: 30px;
  width: 390px;
  height: 281px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  div:last-child {
    margin-top: 50px;
    display: flex;
    position: relative;
    top: 25px;
  }
  p {
    background-color: #f7f7f7;
    width: 170px;
    text-align: center;
    margin: 0px 10px;
    padding: 10px 0px;
    color: #656565;
		cursor: pointer;
  }

  .right {
    background-color: #73972c;
    color: #ffffff;
  }
`;

export const ModalBack = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
`;
